import {
  isEmpty,
  fetchAndConvertToBase64,
  convertBase64ToFile,
  getFirebaseUrlFromFile,
  DEFAULT_UPLOAD_FOLDER
} from '../../../../helpers/common';

export const processFileLinksInContent = async (
  commentData: string,
  folderName = DEFAULT_UPLOAD_FOLDER
): Promise<string> => {
  let processedContent = commentData;

  const tempElement = document.createElement('div');
  tempElement.innerHTML = processedContent || '';
  const linkElements = tempElement.querySelectorAll('div[src]');

  const promises: Promise<void>[] = Array.from(linkElements).map(async (linkElement) => {
    const srclink = linkElement?.getAttribute('src');
    if (!isEmpty(srclink)) {
      if (srclink && srclink.startsWith('https://asana')) {
        const base64Url = await fetchAndConvertToBase64(srclink);
        const fileData = await convertBase64ToFile(base64Url);
        const fileUrl = await getFirebaseUrlFromFile({ file: fileData }, folderName);
        if (fileUrl) {
          const asanaUrlRegex = /https:\/\/asana[^\s"'<>)]*/g;
          processedContent = processedContent?.replace(asanaUrlRegex, fileUrl);
        }
      } else if (
        !srclink?.startsWith('https://firebasestorage') &&
        !srclink?.startsWith('https://figma') &&
        !srclink?.startsWith('/static') &&
        !srclink?.startsWith('https://')
      ) {
        const fileData = await convertBase64ToFile(srclink);
        const fileUrl = await getFirebaseUrlFromFile({ file: fileData }, folderName);
        if (fileUrl) {
          processedContent = processedContent?.replace(srclink || '', fileUrl);
        }
      }
    }
  });

  await Promise.all(promises);
  return processedContent;
};
